/* eslint-disable @typescript-eslint/no-explicit-any */

import { FILTERS } from '../constants';

export const PRIORITY_PRESET_NAMES = {
  withChild: 'withChild',
  default: 'default',
};
export type PriorityPresetsType = keyof typeof PRIORITY_PRESET_NAMES;

export const PRIORITY_PRESETS = {
  [PRIORITY_PRESET_NAMES.withChild]: {
    [FILTERS.FilterConfirmability]: 1000,
    [FILTERS.FilterCancellationPolicy]: 1000,
    [FILTERS.FilterFamilyWithKids]: 100,
  },
};

/**
 * Сортируем фильтры по пресету
 */
export const getFiltersByPriority = (
  filters: any,
  preset: PriorityPresetsType,
) => {
  const priotityWith = PRIORITY_PRESETS[preset];

  if (preset === PRIORITY_PRESET_NAMES.default || !priotityWith) {
    return filters;
  }

  const defaultPriority = 10;

  // добавляем приоритет к фильтрам
  const withPriority = filters.map((filter) => {
    const priority = priotityWith[filter as any] || defaultPriority;
    return { filter, priority };
  });

  const sorted = withPriority.sort((a, b) => b.priority - a.priority);
  return sorted.map((item) => item.filter);
};
